export default __webpack_public_path__ + "static/media/cover.bb18fe3a.png";